// export class CardInfo {
//   instanceId: number;
//   businessProcessId: number;
//   stateId: number;
//   queueId: number;
//   stateLifeCycle: number;
//   fieldColumns: [];
//   cardFields: [];
// }

export class CardInfo {
  businessProcessId: number;
  businessProcessInstanceId: number;
  businessProcessName: string;
  captionText: string;
  color: string;
  creationDate: Date;
  customInteractionQueueConfigId: number;
  detailsText: string;
  fontColor: string;
  interactionSymbolInfo: string;
  modifiedBy: string;
  stateDisplayName: string;
  stateExecutionOrder: number;
  stateId: number;
  stateLifeCycle: number;
  stateModifyDate: Date;
  values: string[]
}

export class InteractionQueue
{
  orderDirection:number;
  orderByColumn;
  columns: InteractionQueueColumn[];
  colors;
}

export class InteractionQueueColumn
{
  public id:number;
  public name:string;
  public columnOrder: number;
  public isEnabled: boolean;
  public type: number;
  public systemField;
  public businessProcessFields:[];
}
